"use client";

import { useCallback } from "react";
import { FEATURE_FLAGS, METRICS_EVENTS } from "@cede/types";
import { ROUTES } from "@/constants/routes";
import { BRAND_THEME } from "@/constants/theme";
import { useMetricsEvents } from "@/hooks/data/useMetricsEvents";
import { useFeatureFlagIsOn, useFeatureFlagValue } from "@/hooks/feature-flags";
import { useActiveTheme } from "@/store/themeStore";
import { useRouter } from "next/navigation";

export const useCryptoComCta = () => {
  const router = useRouter();
  const { trackEvent } = useMetricsEvents();
  const isFeatureEnabled = useFeatureFlagIsOn(FEATURE_FLAGS.CRYPTOCOM_REFEREE_HUB_ENABLE);
  const activeTheme = useActiveTheme();

  // Hide CTA on any branded page (Kraken route, Kraken campaigns, Crypto.com campaigns, etc.)
  const isEnabled = isFeatureEnabled && activeTheme === BRAND_THEME.DEFAULT;
  const rewardAmount = useFeatureFlagValue(FEATURE_FLAGS.CRYPTOCOM_REFEREE_HUB_REWARD_AMOUNT, "");

  const handleClick = useCallback(
    (source: "header" | "main_page") => {
      trackEvent(METRICS_EVENTS.CLICK_CRYPTO_COM_CTA, {
        source,
        reward_amount: rewardAmount || "",
      });
      router.push(ROUTES.CRYPTO_COM_SIGNUP);
    },
    [trackEvent, rewardAmount, router],
  );

  return { isEnabled, rewardAmount, handleClick };
};
